/**
 * Sanea un nombre de archivo para escribirlo en filesystem compartido.
 * Labels de fecha tipo "26/9/2026 — 28/9/2026" traen `/` que el FS interpreta
 * como subdirectorio → ENOENT en writeAsStringAsync (VUELTO-NEGOCIO-3N).
 */
export function sanitizeCsvFileName(fileName: string): string {
  return fileName
    .replace(/[\\/:*?"<>|]/g, '-')
    .replace(/—/g, '_')
    .replace(/\s+/g, '_');
}
